import { SxProps } from '@mui/material';

export const paperProps: SxProps = {
  borderRadius: '8px',
  width: '517px',
  maxHeight: 'none',
  minWidth: '380px',
};

export const title: SxProps = {
  fontSize: '26px',
  fontWeight: 600,
  mt: '14px',
};

export const dialogTitle: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  p: '32px 32px 0 32px',
};

export const closeBtn: SxProps = {
  padding: '10px',
  minWidth: '36px',
  height: '36px',
  width: '36px',
  borderRadius: '8px',
  alignItems: 'centre',

  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
  },
};

export const dialogActions: SxProps = {
  '&.MuiDialogActions-root': {
    padding: '0px 32px 32px',
  },
};

export const dialogContent: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  '&.MuiDialogContent-root': {
    p: '0px 32px 24px 32px',
  },
};
export const rateBox: SxProps = {
  display: 'flex',
  gap: '12px',
  minHeight: '74px',
  mt: '25px',
};

export const starBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: '52px',
  justifyContent: 'space-between',
  position: 'relative',
  cursor: 'pointer',
};

export const textField: SxProps = {
  mt: '20px',
  '& .MuiFormControl-root': {
    height: '120px',
  },
  '& .MuiInputBase-root': {
    height: '100%',
    padding: '6px',
  },
  '& .MuiInputBase-input': {
    height: '100%',
    padding: '10px',
  },
  '& .MuiInputBase-input::placeholder': {
    color: '#14191F66',
    fontSize: '14px',
  },
};

export const textFieldTypo: SxProps = {
  position: 'absolute',
  bottom: '105px',
  right: '45px',
  fontSize: '13px',
};

export const rateTypo: SxProps = {
  opacity: '80%',
  position: 'absolute',
  top: '50px',
  minWidth: 'max-content',
};
